import { render, staticRenderFns } from "./OneTable.vue?vue&type=template&id=cbfa8724&"
import script from "./OneTable.vue?vue&type=script&lang=js&"
export * from "./OneTable.vue?vue&type=script&lang=js&"
import style0 from "./OneTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports